"use client";

import {useState} from "react";
import {Button} from "@/components/ui/button";
import {CalendarClock, MapPin, MessageCircle, Phone} from "lucide-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import LeadDialogForm from "@/app/(pages)/dove-siamo/[slug]/_components/LeadDialogForm";

interface StickyActionsBarProps {
    title: string;
    provincia?: string;
    phone: string;
    mapUrl?: string;
}

export default function StickyActionsBar({title, provincia, phone, mapUrl}: StickyActionsBarProps) {
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState<"default" | "whatsapp" | "info" | "call">("default");

    const handleOpen = (nextMode: "default" | "whatsapp" | "info" | "call") => {
        setMode(nextMode);
        setOpen(true);
    };

    return (
        <>
            <div className="fixed inset-x-0 bottom-0 z-40 pointer-events-none">
                <div className="mx-auto w-full bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_24px_rgba(0,0,0,0.08)] px-3 sm:px-6 py-3">
                    <div className="pointer-events-auto mx-auto w-full max-w-5xl">
                        <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
                            <Button
                                onClick={() => handleOpen("default")}
                                className="h-12 w-full bg-primary text-white gap-2 text-base font-semibold"
                            >
                                <CalendarClock className="h-5 w-5"/>
                                Prenota Appuntamento
                            </Button>
                            <Button
                                onClick={() => handleOpen("whatsapp")}
                                className="h-12 w-full gap-2 text-base font-semibold text-gray-800"
                                variant="outline"
                            >
                                <MessageCircle className="h-5 w-5"/>
                                WhatsApp
                            </Button>
                            <Button
                                onClick={() => handleOpen("call")}
                                className="h-12 w-full gap-2 text-base font-semibold text-gray-800"
                                variant="outline"
                            >
                                <Phone className="h-5 w-5"/>
                                Chiama
                            </Button>
                            <Button
                                asChild
                                className="h-12 w-full gap-2 text-base font-semibold text-gray-800"
                                variant="outline"
                            >
                                <a href={mapUrl || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(title)}`} target="_blank" rel="noreferrer">
                                    <MapPin className="h-5 w-5"/>
                                    Indicazioni
                                </a>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="sm:max-w-xl">
                    <DialogHeader>
                        <DialogTitle>
                            {mode === "whatsapp" ? "Contattaci su WhatsApp" : "Prenota un appuntamento"}
                        </DialogTitle>
                    </DialogHeader>
                    <LeadDialogForm
                        title={title}
                        provincia={provincia}
                        mode={mode}
                        onSubmitted={() => setOpen(false)}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}
